import React, { useState, useEffect, useCallback } from 'react';
import  { Container, Row, Col, Button, Breadcrumb, Table, Modal } from 'react-bootstrap';
import {  useNavigate } from 'react-router-dom';
import { Dropdown } from 'react-bootstrap';
import Header from '../page-layout/header/Header';
import NavMenu from '../navigation/Navmenu';
import Footer from '../page-layout/footer/Footer';
import "react-data-table-component-extensions/dist/index.css";
import { GrokLoading } from '../page-layout/loading/Loading';
import 'bootstrap-icons/font/bootstrap-icons.css';
import { GetJobs, DeleteJob } from '../../utils/axios/JobsAPI';
import { Decrypt } from '../../utils/Helper';
import { ROLE } from "../constants/constants";
import configData from '../../config.json';

import "react-data-table-component-extensions/dist/index.css";
import 'bootstrap-icons/font/bootstrap-icons.css';
import './postJob.css';

const PostJob = () => {
    const [userInfo] = useState(JSON.parse(Decrypt(sessionStorage.getItem('userInfo')))); 

    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [jobs, setJobs] = useState([]);
    const [showDelete, setShowDelete] = useState(false);
    const [selectedJob, setSelectedJob] = useState(null);
    const [filter, setFilter] = useState("active");
    const [showView, setShowView] = useState(false);
    const [selectedJobView, setSelectedJobView] = useState(null);
    const [showReactivate, setShowReactivate] = useState(false);
    const [jobToReactivate, setJobToReactivate] = useState(null);
    const [showDecisionModal, setShowDecisionModal] = useState(false);
    const [decisionTarget, setDecisionTarget] = useState(null);
    const [decisionType, setDecisionType] = useState("");
    const [successMessage, setSuccessMessage] = useState("");
    const [showSuccess, setShowSuccess] = useState(false);

    // Helper to extract clean token safely
    const getCleanToken = useCallback(() => {
        const token = sessionStorage.getItem('token');
        if (!token) return null;
        return token.startsWith('"') ? JSON.parse(token) : token;
    }, []);

    const BackBtn = () => {
        navigate('/home');
    }

    const addRefresh = () => {
        navigate('/home', {state: {myChallengeid: null}});
    }   

    const handleDeleteClick = (job) => {
        setSelectedJob(job);
        setShowDelete(true);
    };

    const handleReactivateClick = (job) => {
        setJobToReactivate(job);
        setShowReactivate(true);
    };

    const handleDecisionClick = (job, type) => {
        setDecisionTarget(job);
        setDecisionType(type);
        setShowDecisionModal(true);
    };

    const handleDownloadJD = async (pdfUploadName) => {
        setLoading(true);
        try {
            const token = sessionStorage.getItem('token');
            const cleanToken = (token && token.startsWith('"')) ? JSON.parse(token) : token;
            
            const url = `${configData.API_ENDPOINT}jobs/download/${pdfUploadName}`;
            
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${cleanToken}`
                }
            });

            const result = await response.json();

            if (response.ok && result.success) {
                const downloadUrl = result.data;
                const link = document.createElement('a');
                link.href = downloadUrl;
                link.setAttribute('download', ''); 
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            } else {
                console.error("Download Error Response:", result.message);
                alert("Failed to fetch download link from server.");
            }
        } catch (error) {
            console.error("JD download requested action failed:", error);
            alert("An error occurred while downloading the job description document.");
        } finally {
            setLoading(false);
        }
    };

    const getJobs = useCallback(async () => {

        // 1. Safety Guard: If userInfo hasn't loaded into state yet, wait.
        if (!userInfo || Object.keys(userInfo).length === 0) {
            return;
        }

        if (!userInfo || !userInfo.RoleId) {
            setJobs([]);
            setLoading(false);
            return;
        }

        if ((userInfo.RoleId === ROLE.COMPANY || userInfo.RoleId === ROLE.COLLEGE) && !userInfo.OrganizationId) {
            console.warn(`User with role ${userInfo.RoleId} lacks an OrganizationId alignment. Access blocked.`);
            setJobs([]);
            setLoading(false);
            return;
        }

        setLoading(true);
        try {
            const jobPayload = {
                RoleId: userInfo.RoleId,
                OrganizationId: userInfo.OrganizationId || null
            };

            // Debugging line: Check what your frontend is actually preparing to send!
            console.log("Frontend sending jobPayload:", jobPayload);

            const response = await GetJobs(jobPayload);

            if (response && response.success) {
                setJobs(response.data || []);
            } else {
                setJobs([]);
            }
        } catch (error) {
            console.error("Failed to fetch jobs:", error);
            setJobs([]);
        } finally {
            setLoading(false);
        }
    }, [userInfo]);

    useEffect(() => {
        // Only fetch if userInfo is verified ready
        if (userInfo && userInfo.RoleId) {
            getJobs();
        }
        // getJobs();
    }, [getJobs]);

    // Update Decision Handlers (Accept/Reject/Reactivate) to use PUT
    const confirmDecision = async () => {
        setLoading(true);
        try {
            const jobId = decisionTarget.id || decisionTarget._id;
            const token = sessionStorage.getItem('token');
            const cleanToken = (token && token.startsWith('"')) ? JSON.parse(token) : token;

            let url = "";            

            if (decisionType === "accept") {
                url = `${configData.API_ENDPOINT}jobs/${jobId}`;                
            } else {
                url = `${configData.API_ENDPOINT}jobs/reject/${jobId}`;               
            }

            const response = await fetch(url, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${cleanToken}`
                },
                body: JSON.stringify(decisionType === "accept"
                    ? { ...decisionTarget, status: "active", UpdatedBy: userInfo._id }
                    : { DeletedBy: userInfo._id }
                )
            });

            if (response.ok) {
                console.log("Action Successful");
                await getJobs();

                if (decisionType === "accept") {
                    setSuccessMessage(`Job post for ${decisionTarget?.company || 'the company'} approved successfully!`);
                } else {
                    setSuccessMessage(`Job post for ${decisionTarget?.company || 'the company'} rejected.`);
                }
                
                setShowSuccess(true);

                setTimeout(() => {
                    setShowSuccess(false);
                }, 3000);

            } else {
                const errorText = await response.text();
                console.error("Server Error:", errorText);
            }
        } catch (error) {
            console.error("Network/Action failed:", error);
        } finally {
            setLoading(false);
            setShowDecisionModal(false);
            setDecisionTarget(null);
        }
    };

    const confirmReactivate = async () => {
        const token = getCleanToken();
        if (!token) {
            alert("Session invalid. Please log in again.");
            return;
        }

        setLoading(true);
        try {
            const jobId = jobToReactivate.id || jobToReactivate._id;
            const url = `${configData.API_ENDPOINT}jobs/${jobId}`;

            const bodyPayload = {
                ...jobToReactivate,
                status: "active",
                UpdatedBy: userInfo._id
            };

            const response = await fetch(url, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify(bodyPayload)
            });
            if (response.ok) {
                await getJobs();

                setSuccessMessage("Job reactivated successfully!");
                setShowSuccess(true);

                setTimeout(() => {
                    setShowSuccess(false);
                }, 3000);
            } else {               
                const errorData = await response.json();
                console.error("Validation Error:", errorData.message);
            }
        } catch (error) {
            console.error("Reactivation failed:", error);
        } finally {
            setLoading(false);
            setShowReactivate(false);
            setJobToReactivate(null);
        }
    };

    const handleConfirmDelete = async () => {
        setLoading(true);
        try {
            const jobId = selectedJob.id || selectedJob._id;
            const url = `${configData.API_ENDPOINT}jobs/${jobId}`;
            const token = sessionStorage.getItem('token');
            const cleanToken = (token && token.startsWith('"')) ? JSON.parse(token) : token;

            const response = await fetch(url, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${cleanToken}`
                },
                body: JSON.stringify({ DeletedBy: userInfo._id })
            });
            if (response.ok) {
                await getJobs();

                setSuccessMessage("Job deleted successfully!");
                setShowSuccess(true);

                setTimeout(() => {
                    setShowSuccess(false);
                }, 3000);
            }
        } catch (error) {
            console.error("Delete request failed:", error);
        } finally {
            setLoading(false);
            setShowDelete(false);
        }
    };

    const filteredJobs = jobs.filter(job => job.status === filter);

    return (
        <div className='page'>
        {loading && <GrokLoading />}
            <NavMenu />
            <Header />
            <div className='page-wrapper'>
                <Container fluid>
                    <div className='page-header d-print-none'>
                        <Row className='g-2 align-items-center pb-1'>
                            <div>
                                <Breadcrumb className="custom-breadcrumb">
                                    <Breadcrumb.Item  onClick={() => addRefresh()}>Home</Breadcrumb.Item>
                                    <Breadcrumb.Item active>Latest Job Openings</Breadcrumb.Item>
                                </Breadcrumb>
                            </div>
                            <Col style={{ display: 'flex', alignItems: 'center' }}>
                                <Button className='nave-icon' variant='outline' size='sm' title='MyChallenges'>
                                    <span>
                                    <svg xmlns="http://www.w3.org/2000/svg" height="1em" width="1em" viewBox="0 -960 960 960" stroke="currentColor" fill="currentColor"><path d="M160-120q-33 0-56.5-23.5T80-200v-440q0-33 23.5-56.5T160-720h160v-80q0-33 23.5-56.5T400-880h160q33 0 56.5 23.5T640-800v80h160q33 0 56.5 23.5T880-640v440q0 33-23.5 56.5T800-120H160Zm0-80h640v-440H160v440Zm240-520h160v-80H400v80ZM160-200v-440 440Z"/>
                                    </svg>
                                    </span>
                                </Button>
                                <h2 className="page-title">Latest Job Openings</h2>
                            </Col>
                            <Col className="mb-1 me-3 col-md-auto">
                                <button className='newBtn_style' onClick={() => BackBtn()}>
                                    <span><svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 512 512" height="1.5em" width="1.5em" xmlns="http://www.w3.org/2000/svg"><path fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="32" d="M249.38 336L170 256l79.38-80m-68.35 80H342"></path><path fill="none" strokeMiterlimit="10" strokeWidth="32" d="M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"></path></svg></span>
                                    &nbsp;&nbsp;Back
                                </button>
                            </Col>
                        </Row>
                    </div>

                    <div className='py-3'>
                        <Row className="mb-3">
                            <Col className="d-flex justify-content-end align-items-center gap-4">                           
                                <Dropdown>
                                    <Dropdown.Toggle variant="light" className="border job-filter-btn">
                                        <i className="bi bi-funnel me-1"></i>
                                        {filter.charAt(0).toUpperCase() + filter.slice(1)} Jobs
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu>
                                        <Dropdown.Item onClick={() => setFilter("active")}>
                                            Active
                                        </Dropdown.Item>

                                        {/* Hide Deleted Filter option for Company/Industry Logins */}
                                        {userInfo?.RoleId !== ROLE.COMPANY && (
                                        <Dropdown.Item onClick={() => setFilter("deleted")}>
                                            Deleted
                                        </Dropdown.Item>
                                        )}

                                        <Dropdown.Item onClick={() => setFilter("new")}>
                                            New
                                        </Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown>
                            
                                <button className="backBtn_style" onClick={() => navigate('/addjob')}>
                                    Add Job
                                </button>
                            </Col>
                        </Row>
                        {showSuccess && (
                            <div className="alert alert-success alert-dismissible fade show mx-3 mt-3" role="alert">
                                {successMessage}
                                <button
                                    type="button"
                                    className="btn-close"
                                    onClick={() => setShowSuccess(false)}
                                ></button>
                            </div>
                        )}
                        <div className='card mb-3 mb-lg-5 '>
                            <Table bordered hover responsive>
                                <thead>
                                    <tr>
                                        <th style={{ width: "20%" }}>Company</th>
                                        <th style={{ width: "20%" }}>Job Title</th>
                                        <th style={{ width: "20%" }}>Location</th>
                                        <th style={{ width: "20%" }}>Posted Date</th>
                                        <th style={{ width: "25%" }}>Actions</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {filteredJobs.length === 0 ? (
                                        <tr>
                                            <td colSpan="5" className="text-center">
                                                No jobs found!!
                                            </td>
                                        </tr>
                                    ) : (
                                        filteredJobs.map((job) => {
                                            const currentId = job._id || job.id;
                                            return (
                                                <tr key={currentId}>
                                                    <td>{job.company}</td>
                                                    <td>{job.title}</td>
                                                    <td>{job.location}</td>
                                                    <td>{job.date}</td>
                                                    <td className="text-center align-middle">
                                                        <div className="d-flex justify-content-center align-items-center custom-gap">
                                                            <Button
                                                                size="sm"
                                                                className="action-btn"
                                                                onClick={() => {
                                                                    setSelectedJobView(job);
                                                                    setShowView(true);
                                                                }}
                                                            >
                                                                View
                                                            </Button>

                                                            {/* Active Jobs */}
                                                            {job.status === "active" && userInfo?.RoleId !== ROLE.COMPANY &&  (
                                                                <>
                                                                    <Button
                                                                        size="sm"
                                                                        variant="warning"
                                                                        onClick={() => navigate(`/addjob/${job.id}`, { state: { job } })}
                                                                    >
                                                                        Edit
                                                                    </Button>{' '}

                                                                    <Button
                                                                        size="sm"
                                                                        variant="danger"
                                                                        onClick={() => handleDeleteClick(job)}
                                                                    >
                                                                        Delete
                                                                    </Button>
                                                                </>
                                                            )}

                                                            {/* Deleted Jobs */}
                                                            {job.status === "deleted" && userInfo?.RoleId !== ROLE.COMPANY && (
                                                                <Button
                                                                    size="sm"
                                                                    variant="success"
                                                                    onClick={() => handleReactivateClick(job)}
                                                                >
                                                                    Reactivate
                                                                </Button>
                                                            )}

                                                            {/* New / Pending Jobs */}
                                                            {job.status === "new" && (
                                                                <>
                                                                    {userInfo?.RoleId !== ROLE.COMPANY && (
                                                                        <i
                                                                            className="bi bi-check-lg text-success action-icon"
                                                                            title="Accept"
                                                                            onClick={() => handleDecisionClick(job, "accept")}
                                                                        ></i>

                                                                    )}

                                                                    {userInfo?.RoleId === ROLE.COMPANY && (

                                                                        <Button
                                                                            size="sm"
                                                                            variant="warning"
                                                                            onClick={() => navigate(`/addjob/${job.id}`, { state: { job } })}
                                                                        >
                                                                            Edit
                                                                        </Button>

                                                                    )}

                                                                    <i
                                                                        className="bi bi-x-lg text-danger action-icon"
                                                                        title="Reject"
                                                                        onClick={() => handleDecisionClick(job, "reject")}
                                                                    ></i>
                                                                </>
                                                            )}
                                                        </div>
                                                        </td>
                                                    </tr>
                                                );
                                            }))}
                                </tbody>
                            </Table>

                            <Modal show={showDelete} onHide={() => setShowDelete(false)} backdrop="static" keyboard={false}>
                                <Modal.Header closeButton>
                                    <Modal.Title>Confirm Delete</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    Are you sure you want to delete this job?
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button variant="secondary" onClick={() => setShowDelete(false)}>
                                        Cancel
                                    </Button>
                                    <Button variant="danger" onClick={handleConfirmDelete}>
                                        Delete
                                    </Button>
                                </Modal.Footer>
                            </Modal>

                            {/* Reactivate Confirmation Modal */}
                            <Modal show={showReactivate} onHide={() => setShowReactivate(false)} centered backdrop="static" keyboard={false}>
                                <Modal.Header closeButton>
                                    <Modal.Title>Confirm Reactivation</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    Are you sure you want to reactivate the job post for <strong>{jobToReactivate?.company}</strong>?
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button variant="secondary" onClick={() => setShowReactivate(false)}>
                                        Cancel
                                    </Button>
                                    <Button variant="success" onClick={confirmReactivate}>
                                        Reactivate
                                    </Button>
                                </Modal.Footer>
                            </Modal>

                            <Modal
                                show={showDecisionModal}
                                onHide={() => setShowDecisionModal(false)}
                                centered
                                backdrop="static"
                                keyboard={false}
                            >
                                <Modal.Header closeButton>
                                    <Modal.Title>
                                        {decisionType === "accept" ? "Confirm Approval" : "Confirm Rejection"}
                                    </Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    Are you sure you want to <strong>{decisionType}</strong> the job post for
                                    <strong> {decisionTarget?.company}</strong>?
                                    {decisionType === "reject" && <p className="text-danger mt-2"><small>Note: This action will permanently remove the post.</small></p>}
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button variant="secondary" onClick={() => setShowDecisionModal(false)}>
                                        Cancel
                                    </Button>
                                    <Button
                                        variant={decisionType === "accept" ? "success" : "danger"}
                                        onClick={confirmDecision}
                                    >
                                        {decisionType === "accept" ? "Approve" : "Reject"}
                                    </Button>
                                </Modal.Footer>
                            </Modal>

                            <Modal show={showView} onHide={() => setShowView(false)} centered>
                                <Modal.Header closeButton>
                                    <Modal.Title>Details</Modal.Title>
                                </Modal.Header>

                                <Modal.Body style={{ maxHeight: "400px", overflowY: "auto" }}>
                                    {selectedJobView && (
                                        <div>
                                            <p><strong>Company:</strong> <span>{selectedJobView.company}</span></p>
                                            <p><strong>Job Title:</strong> {selectedJobView.title}</p>
                                            <p><strong>Location:</strong> {selectedJobView.location}</p>
                                            <p><strong>Posted Date:</strong> {selectedJobView.date}</p>
                                            <p><strong>Description:</strong> {selectedJobView.description}</p>
                                            <p><strong>Experience:</strong> {selectedJobView.experience}</p>
                                            {selectedJobView.pdfUpload && (
                                                <p className="mt-3">
                                                    <strong>Job Description File:</strong>{" "}
                                                    <Button
                                                        variant="outline-primary"
                                                        size="sm"
                                                        className="ms-2 align-middle"
                                                        onClick={() => handleDownloadJD(selectedJobView.pdfUpload)}
                                                        title="Download Document"
                                                    >
                                                        <i className="bi bi-download me-1"></i> Download JD
                                                    </Button>
                                                </p>
                                            )}
                                        </div>
                                    )}
                                </Modal.Body>
                            </Modal>                            
                        </div>
                    </div>
                </Container>
                <Footer />
            </div>
        </div>
    )
}

export default PostJob;